<!--错题报告-->
<template>
    <div class="answer-report">
        <TopBar :TopBarData="questionArr"/>
        <div class="answer-content" v-if="ans_list.length !== 0">
            <div class="route">
                <span @click="goQuestion">
                    我的题库
                </span>
                <span></span>
                <span @click="goExercises">答题练习</span>
                <span></span>
                <span class="hover">错题报告</span>
            </div>
            <div class="answer-title">
                <div class="title-warp">
                    <h1>{{crs_name}}</h1>
                    <div class="small-title">
                        <span>{{name}}</span>
                        <span>共{{total_ques}}题</span>
                    </div>
                </div>
                <div class="button-warp">
                    <my-button
                            v-for="(item,index) in buttonList"
                            :key="index"
                            :buttonList="item"/>
                </div>
            </div>
            <div class="subject_list" v-if="list.correct_data.length !== 0">
                <div class="count-list">
                    <p class="count">{{list.correct_data.length}}</p>
                    <p class="count-text">答对题数</p>
                </div>
                <ul class="item-list">
                    <li
                            class="item blue_color"
                            v-for="(i,index) in list.correct_data"
                            :key="index"
                    >{{i}}
                    </li>
                </ul>
            </div>
            <div class="subject_list" v-if="list.error_data.length !== 0">
                <div class="count-list">
                    <p class="count err-count">{{list.error_data.length}}</p>
                    <p class="count-text">答错题数</p>
                </div>
                <ul class="item-list">
                    <li
                            class="item red_color"
                            v-for="(i,index) in list.error_data"
                            :key="index"
                    >{{i}}
                    </li>
                </ul>
            </div>
            <div class="subject_list" v-if="list.no_ans_data.length !== 0">
                <div class="count-list">
                    <p class="count on-count">{{list.no_ans_data.length}}</p>
                    <p class="count-text">未答题数</p>
                </div>
                <ul class="item-list">
                    <li
                            v-for="(i,index) in list.no_ans_data"
                            :key="index"
                            class="item grey_color"
                    >{{i}}
                    </li>
                </ul>
            </div>
        </div>
        <my-bottom v-if="list.no_ans_data.length !== 0"/>
    </div>
</template>

<script>
    import TopBar from "../../components/common/TopBar"
    import myButton from "../../components/common/Button"
    import myBottom from "../../components/common/MyBottom"

    export default {
        name: "AnswerReport",
        data() {
            return {
                //答卷id
                ans_id: '',
                //试题id
                ques_id: '',
                //已做题目
                ans_num: 0,
                //课程名
                crs_name: '',
                //总条数
                total_ques: '',
                //小标题
                name: '',
                //题目数组
                ans_list:'',
                //页面数据列表
                list: {
                    correct_data: [],
                    error_data: [],
                    no_ans_data: []
                },
                classColor: 'grey_color',
                buttonList: [
                    {
                        colorClass: 'blue_color',
                        route: '/AnswerSheet',
                        msg: '查看解析',
                        ques_id: '',
                        ans_id: '',
                        ans_num: '',
                        crs_name: '',
                        name: '',
                        type: 'value'
                    }, {
                        colorClass: 'grey_color',
                        route: '/MyQuestion',
                        msg: '返回',
                        type: 'route'
                    },
                    // {
                    //     colorClass: 'red_color',
                    //     route: '/1121',
                    //     msg: '重做'
                    // }
                ],
                //给首页传的课程id跟课程title的下标
                questionArr: []
            }
        },
        components: {
            TopBar,
            myButton,
            myBottom
        },
        mounted() {
            this.getUpPageData();
            this.getManagement();
        },
        methods: {
            getUpPageData() {
                this.ques_id = this.$route.query.ques_id;
                this.ans_id = this.$route.query.ans_id;
                this.ans_num = this.$route.query.ans_num;
                this.crs_name = this.$route.query.crs_name;
                this.name = this.$route.query.name;
                //给button赋值
                this.buttonList[0].ans_id = this.ans_id;
                this.buttonList[0].ans_num = this.ans_num;
                this.buttonList[0].crs_name = this.crs_name;
                this.buttonList[0].name = this.name;
                this.buttonList[0].ques_id = this.ques_id;
            },
            getManagement() {
                this.$get(this.BASEURL + '/prequestion/mobile/management',
                    {
                        ans_id: this.ans_id,
                    }
                ).then((res) => {
                    if (res.code === 200) {
                        this.ans_list = res.data.ans_list;
                        this.list.correct_data = res.correct_data;
                        this.list.error_data = res.error_data;
                        this.list.no_ans_data = res.no_ans_data;
                        this.total_ques = res.data.total_num;
                        this.questionArr.push(res.crs_id, res.data.type)
                    } else {
                        this.$message({
                            message: res.error,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            //返回答题练习
            goExercises() {
                this.$router.push({
                    path: '/AnswerExercises',
                    query: {
                        ques_id: this.ques_id,
                        ans_num: this.ans_num,
                        crs_name: this.crs_name,
                        name: this.name
                    }
                });
            },
            //回到首页
            goQuestion() {
                this.$router.push({
                    path: '/myQuestion',
                    query: {
                        crs_id: this.questionArr[0],
                        type: this.questionArr[1],
                    }

                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .answer-report {
        position: relative;
        width: 100%;
        height: 100vh;
        min-height: 100vh;
        max-height: 100%;
        background-color: #F5F5F5;
        .answer-content {
            margin: 0 auto;
            width: 1200px;
            padding-top: 85px;
            min-height: calc(100% - 60px);
            box-sizing: border-box;
            padding-bottom: 50px;
            background-color: #F5F5F5;
            .route {
                margin: 24px 0;
                span {
                    font-size: 14px;
                    line-height: 20px;
                    color: #666;
                    font-weight: 400;
                    display: inline-block;
                    cursor: pointer;
                }
                span:nth-child(2) {
                    position: relative;
                    padding: 0 16px;
                    &:before {
                        content: " ";
                        display: inline-block;
                        height: 7px;
                        width: 7px;
                        border-width: 1px 1px 0 0;
                        border-color: #999999;
                        border-style: solid;
                        -webkit-transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
                        transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0) translateY(-50%);
                        position: absolute;
                        top: 50%;
                        right: 50%;
                        margin-top: -6px;
                    }
                }
                span:nth-child(4) {
                    position: relative;
                    padding: 0 16px;
                    &:before {
                        content: " ";
                        display: inline-block;
                        height: 7px;
                        width: 7px;
                        border-width: 1px 1px 0 0;
                        border-color: #999999;
                        border-style: solid;
                        -webkit-transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
                        transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0) translateY(-50%);
                        position: absolute;
                        top: 50%;
                        right: 50%;
                        margin-top: -6px;
                    }
                }
                .hover {
                    cursor: default;
                    color: #3D89FB;
                }
            }
            .answer-title {
                height: 60px;
                padding: 37px 32px;
                border-radius: 4px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                background-color: #fff;
                .title-warp {
                    margin-right: 20px;
                    h1 {
                        font-size: 20px;
                        font-weight: 400;
                        line-height: 26px;
                        margin-bottom: 16px;
                        color: #333333;
                    }
                    .small-title {
                        font-size: 14px;
                        font-weight: 400;
                        color: #666666;
                        span {
                            display: inline-block;
                            line-height: 19px;
                        }
                        span:nth-child(2) {
                            padding-left: 16px;
                            color: #3D89FB;
                        }
                    }
                }
                .button-warp {
                    display: flex;
                }
            }
            .subject_list {
                display: flex;
                align-items: center;
                padding: 35px 50px 30px 35px;
                margin-top: 24px;
                border-radius: 4px;
                background-color: #fff;
                .count-list {
                    position: relative;
                    padding-right: 27px;
                    height: 70px;
                    &:before {
                        content: "";
                        position: absolute;
                        top: 0;
                        right: 0;
                        bottom: 0;
                        border-right: 1px solid #999;
                        -webkit-transform: scaleX(.5);
                        -webkit-transform-origin: 0 0;
                    }
                    .count {
                        font-size: 40px;
                        line-height: 50px;
                        font-family: DIN;
                        font-weight: 700;
                        text-align: center;
                        color: #3D89FB;
                    }
                    .err-count {
                        color: #F56C6C;
                    }
                    .on-count {
                        color: #999;
                    }
                    .count-text {
                        font-size: 14px;
                        font-family: PingFang SC;
                        font-weight: 400;
                        line-height: 20px;
                        color: #999999;
                    }
                }
                .item-list {
                    display: flex;
                    flex-wrap: wrap;
                    margin-left: 28px;
                    .item {
                        width: 30px;
                        height: 30px;
                        line-height: 30px;
                        margin-left: 11px;
                        margin-bottom: 12px;
                        text-align: center;
                        color: #fff;
                        font-family: DIN;
                        font-size: 16px;
                        font-weight: 700;
                        border-radius: 50%;
                    }
                    .blue_color {
                        background-color: #3D89FB;
                    }
                    .red_color {
                        background-color: #F56C6C;
                    }
                    .grey_color {
                        background-color: #999;
                    }
                }
            }
        }
    }
</style>
